import type { Permission } from "./permissions";
import { useAuth } from "./useAuth";

/** True if the user holds the permission. For hiding whole subtrees prefer <Guard>. */
export function usePermission(permission: Permission): boolean {
  const { user } = useAuth();
  return user?.permissions.includes(permission) ?? false;
}

/** AND — true only if the user holds every permission. */
export function usePermissions(...perms: Permission[]): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return perms.every((p) => user.permissions.includes(p));
}

/** OR — true if the user holds any of the permissions. */
export function useAnyPermission(...perms: Permission[]): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return perms.some((p) => user.permissions.includes(p));
}
